import React, {Component} from 'react';
//import io from 'socket.io-client';
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import {
    AiOutlineUsergroupAdd,
    FaAngleLeft,
    FaSms,
    FiLogIn,
    MdCarRental,
    MdOutlineNotificationsActive, MdOutlinePassword,
    MdOutlineSettingsSuggest,
    RiLockPasswordLine,
    RiWifiLine,
    SlSpeedometer,
    TbHelpHexagon,
} from "react-icons/all";
import {NavLink} from "react-router-dom";
import {toast} from "react-toastify";
import API from "../../services/API";
import Toast from "../Common/Toast";

String.prototype.hashCode = function() {
    let hash = 0,
        i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

class Configs extends Component {
    state = {
        cars: [],
        isLoaded: false,
        activeCar: window.localStorage.getItem("_ac" ),
        showModalSpeed : false,
        showModalPanelPass : false,
        maxSpeed : 0,
        panelPass : window.localStorage.getItem("password"),
        connection_type : window.localStorage.getItem("connection_type"),
        appPass : '',
        appOldPass: '',
        showAppPassModal: false
    }

    onInputChange = (val) => {

        const inputName = val.target.name;
        this.setState({[inputName]: val.target.value});
    }
    setAppPass = () => {
        const oldPass = window.localStorage.getItem("_fToken");
        const currentPass = this.state.appOldPass.hashCode().toString()

        if(oldPass && oldPass !== currentPass) {
            toast.warn('پسورد کنونی صحیح نمی باشد')
        }
        else {
            const str = this.state.appPass;
            window.localStorage.setItem("_fToken" , str.hashCode());
            this.setState({showAppPassModal: false})
            toast.success('کلمه عبور ورود به نرم افزار با موفقیت تنظیم شد')
        }

    }
    sendToSocket = (command) => {
        const ConnectionType = window.localStorage.getItem("connection_type");
        if(ConnectionType === 'internet') {
            const request = {
                'mobile': this.state.cars[this.state.activeCar].main_phone,
                'device': this.state.cars[this.state.activeCar].car_code,
                'password': window.localStorage.getItem("password"),
                'command': command
            };
            this.setState({isLoaded: false})
            API.socketSendData(request)
                .then((response) => {
                    toast.success('دستور با موفقیت به دستگاه ارسال شد')
                    this.setState({isLoaded: true})
                })
        }
        else {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(!check) {
                toast.error('شما در حال استفاده در کامپیوتر هستید، امکان ارسال پیامک با استفاده از کامپیوتر وجود ندارد. لطفا نحوه ارتباط را به حالت اینترنتی تغییر دهید ');
                return false;
            }
            let body = '*' + command.replace('-','*') + '#';

            if (navigator.userAgent.match(/Android/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

            }
            if (navigator.userAgent.match(/iPhone/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
            }
        }

    }

    render() {
        return (
            <React.Fragment>

                {
                    !this.state.isLoaded && <Loading />
                }
<Actionbar title='تنظیمات ' noBack={1}/>
                <Toast/>
                {
                    this.state.showModalSpeed &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12">
                                <div className="row modal-card">
                                    <div className="col-12 text-white text-center py-3 fw-bold">
                                       تنظیم حداکثر سرعت خودرو

                                        <select id="car-list-select" className='my-3'
                                                value={window.localStorage.getItem("_ac" )}
                                                onChange={
                                                    (val) => {
                                                        this.setState({
                                                            'activeCar': parseInt(val.target.value),
                                                            maxSpeed: this.state.cars[val.target.value].Speedmax
                                                        })

                                                    }
                                                }
                                        >
                                            {
                                                this.state.cars.map((car, index) => {

                                                    return (
                                                        <option className="row transaction-item" key={car.car_code}
                                                                value={index}>
                                                            {car.car_name}
                                                            &nbsp;
                                                            (

                                                            {car.car_code}

                                                            )

                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="form-floating col-12 mt-2">
                                            <input type="tel"
                                                   className="form-control px-5 bg-transparent text-white text-right "
                                                   id="maxSpeed" name="maxSpeed"
                                                   placeholder="حداکثر سرعت خودرو"
                                                   onChange={this.onInputChange}
                                                   value={this.state.maxSpeed}

                                            />
                                            <label htmlFor="maxSpeed" className="ms-2 text-light right-0 small">
                                                حداکثر سرعت خودرو
                                                &nbsp;
                                                {this.state.cars[this.state.activeCar].car_name}
                                            </label>
                                            <div role='button' className='text-danger mt-3 text-small-2'
                                               onClick={
                                                   () => {
                                                       const command = `speed-0`;
                                                       this.sendToSocket(command);
                                                       this.setState({showModalSpeed: false})
                                                   }
                                               }
                                            >
                                               حذف حداکثر سرعت
                                            </div>
                                        </div>
                                    </div>



                                    <div className="col-7 my-2 ">
                                        <button className='btn bg-success text-white
                                        text-small-1 w-100 p-2'
                                                onClick={
                                                    () => {
                                                        const command = `speed-${this.state.maxSpeed}`;
                                                        this.sendToSocket(command);
                                                        this.setState({showModalSpeed: false})
                                                    }
                                                }
                                        >
                                            ثبت سرعت
                                        </button>
                                    </div>
                                    <div className="col-5 my-2">


                                        <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                                onClick={() => {
                                                    this.setState({showModalSpeed: false})
                                                }}
                                        >

                                            انصراف
                                        </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }


                {
                    this.state.showModalPanelPass &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12">
                                <div className="row modal-card">
                                    <div className="col-12 text-white text-center py-3 fw-bold">
                                       تغییر کلمه عبور پنل ردیابی

                                        <select id="car-list-select" className='my-3'
                                                onChange={
                                                    (val) => {
                                                        this.setState({'activeCar': parseInt(val.target.value)})
                                                    }
                                                }
                                        >
                                            {
                                                this.state.cars.map((car, index) => {

                                                    return (
                                                        <option className="row transaction-item" key={car.car_code}
                                                                value={index}>
                                                            {car.car_name}
                                                            &nbsp;
                                                            (

                                                            {car.car_code}

                                                            )

                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="form-floating col-12 mt-2">
                                            <input type="tel"
                                                   className="form-control px-5 bg-transparent text-white text-right "
                                                   id="panelPass" name="panelPass"
                                                   placeholder="پسورد پنل"
                                                   onChange={this.onInputChange}
                                                   value={this.state.panelPass}

                                            />
                                            <label htmlFor="panelPass" className="ms-2 text-light right-0 small">
                                                پسورد دستگاه
                                                &nbsp;
                                                {this.state.cars[this.state.activeCar].car_name}
                                            </label>


                                        </div>

                                    </div>

                                    <div className="col-12 text-white text-small-1"
                                         onClick={
                                             () => {
                                                 const command = `pass?`;
                                                 this.sendToSocket(command);
                                                 this.setState({showModalPanelPass: false})
                                             }
                                         }
                                    >
                                        در صورتی که کلمه عبور و یا نام کاربری خود را فراموش کرده اید برای دریافت آنها
                                        &nbsp;
                                        <strong className='text-info'>اینجا</strong>
                                        &nbsp;
                                        کلیک کنید

                                    </div>
                                    <div className="col-7 my-2 ">
                                        <button className='btn bg-success text-white
                                        text-small-1 w-100 p-2'
                                                onClick={
                                                    () => {
                                                        const mobile = window.localStorage.getItem("mobile");


                                                        API.changePass(mobile, this.state.panelPass)
                                                            .then((response) => {
                                                                const command = `npass${this.state.panelPass}`;
                                                                this.sendToSocket(command);
                                                                this.setState({showModalPanelPass: false})
                                                            })

                                                    }
                                                }
                                        >
                                           تغییر پسورد
                                        </button>
                                    </div>
                                    <div className="col-5 my-2">


                                        <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                                onClick={() => {
                                                    this.setState({showModalPanelPass: false})
                                                }}
                                        >

                                            انصراف
                                        </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {
                    this.state.showAppPassModal &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12">
                                <div className="row modal-card">
                                    <div className="col-12 text-white text-center py-3 fw-bold">
                                      تنظیم کلمه عبور ورود به اپلیکیشن

                                        <div className="form-floating col-12 mt-5">
                                            <input type="password"
                                                   className="form-control px-5 bg-transparent text-white text-right "
                                                   id="appOldPass" name="appOldPass"
                                                   placeholder="پسورد کنونی"
                                                   onChange={this.onInputChange}
                                                   value={this.state.appOldPass}

                                            />
                                            <label htmlFor="appPass" className="ms-2 text-light right-0 small">
                                                پسورد کنونی

                                            </label>


                                        </div>

                                        <div className="form-floating col-12 mt-2">
                                            <input type="password"
                                                   className="form-control px-5 bg-transparent text-white text-right "
                                                   id="appPass" name="appPass"
                                                   placeholder="پسورد پنل"
                                                   onChange={this.onInputChange}
                                                   value={this.state.appPass}

                                            />
                                            <label htmlFor="appPass" className="ms-2 text-light right-0 small">
                                                پسورد جدید

                                            </label>


                                        </div>

                                    </div>

                                    <div className="col-12 text-white text-small-2"

                                    >
                                    در صورتی که تا کنون پسوردی تعیین نکرده اید پسورد کنونی را خالی بگذارید.

                                    </div>
                                    <div className="col-7 my-2 ">
                                        <button className='btn bg-success text-white
                                        text-small-1 w-100 p-2'
                                                onClick={this.setAppPass}
                                        >
                                           تغییر پسورد
                                        </button>
                                    </div>
                                    <div className="col-5 my-2">


                                        <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                                onClick={() => {
                                                    this.setState({showAppPassModal: false})
                                                }}
                                        >

                                            انصراف
                                        </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }



                <nav className="container-fluid profile-list-items mt-5">
                    <div className="col-12 pt-2 ">

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item"  >

                        <div className="col-1">
                            <AiOutlineUsergroupAdd className="text-white list-icon"/>
                        </div>
                        <NavLink className="col-9 menu-text " to="/manage-users">
                           افزودن و حذف کاربران
                        </NavLink>
                        <div className="col-1"
                        onClick={() => {toast(

                            'به کاربر اضافه شده دسترسی ارتباط پیامکی داده می شود(هیچکدام از کاربران اضافه شده اجازه شنود ندارند)'

                        )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" >

                        <div className="col-1">
                            <MdCarRental className="text-white list-icon"/>
                        </div>
                        <NavLink className="col-9 menu-text " to="/manage-cars" >
                           افزودن و حذف خودرو
                        </NavLink>
                        <div className="col-1"
                             onClick={() => {toast(

                            '       امکان افزودن چند خودرو و کنترل همزمان تمامی آنها\n'

                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <SlSpeedometer className="text-white list-icon"/>
                        </div>
                        <div className="col-9 menu-text "
                             onClick={() => {
                                 this.setState({showModalSpeed: true})
                             }}
                        >
                           تنظیم حداکثر سرعت
                        </div>
                        <div className="col-1"
                             onClick={() => {toast(

                                 '  اخطار سرعت غیر مجاز توسط تماس تلفنی و پیامک'

                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>

                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item"
                    onClick={ () => {
                        this.setState({
                            showAppPassModal :  true
                        })
                    }}
                    >

                        <div className="col-1">
                            <RiLockPasswordLine className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           تنظیم کلمه عبور ورود به اپ
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" >

                        <div className="col-1">
                            <MdOutlineNotificationsActive className="text-white list-icon"/>
                        </div>
                        <NavLink className="col-9 menu-text "  to="/notifications-config">
                            تنظیمات اخطار
                        </NavLink>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '  اعلام اخطار و هشدار به صورت اینترنتی'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item"
                         onClick={() => {
                             this.setState({showModalPanelPass: true})
                         }}
                    >

                        <div className="col-1">
                            <MdOutlinePassword className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           ویرایش گذرواژه پنل ردیابی
                        </div>

                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </div>
     {/*               <div className="row mt-4 rtl px-4 menu-list-item" >

                        <div className="col-1">
                            <MdOutlineLockReset className="text-white list-icon"/>
                        </div>
                        <NavLink className="col-9 menu-text " to="" >
                          بازگشت به تنظیمات اولیه
                        </NavLink>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '  جهت انتقال مالکیت ، دستگاه به تنطیمات اولیه بر می گردد '
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </div>*/}
{/*                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <RiEqualizerLine className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
تنظیم صدا
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </NavLink>*/}
                    <div className="row mt-4 rtl px-4 menu-list-item"
                    onClick={ () => {
                        localStorage.removeItem("mobile");
                        localStorage.removeItem("password");
                        localStorage.removeItem("_ac");
                        localStorage.removeItem("connection_type");
                        window.location.replace('/')
                    }
                    }
                    >

                        <div className="col-1">
                            <FiLogIn className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                            ورود مجدد
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item"
                    onClick={ () => {

                    }
                    }
                    >

                        <div className="col-1">
                            {
                                this.state.connection_type === 'internet' ?
                                    <RiWifiLine className="text-white list-icon"/> :
                                    <FaSms className="text-white list-icon"/>
                            }
                        </div>
                        <div className="col-10 menu-text ">
                            <select  id="car-list-select" className='text-right text-white custom-select'
                                     defaultValue={this.state.connection_type}
                            onChange={
                                (val) => {
                                    if(val.target.value !== "0") {
                                        window.localStorage.setItem("connection_type" , val.target.value)
                                        this.setState({
                                            'connection_type' : val.target.value
                                        })
                                    }
                                }
                            }

                            >

                                <option value="sms">نحوه ارتباط: پیامکی</option>
                                <option value="internet">نحوه ارتباط: اینترنتی</option>

                            </select>
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item"  >

                        <div className="col-1">
                            <MdOutlineSettingsSuggest className="text-white list-icon"/>
                        </div>
                        <NavLink className="col-9 menu-text " to="/advanced-setting">
                          تنظیمات پیشرفته
                        </NavLink>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '  استفاده از این قسمت برای افراد مبتدی پیشنهاد نمی شود ، جهت راهنمایی با پشتیبان فنی تماس بگیرد'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>
                </nav>

                <Navbar />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if (!mobile && !password) {
            window.location.replace('/')
        }
        API.getCarData(mobile, password)
            .then((response) => {
                this.setState({
                    isLoaded: true,
                    'cars': response.car_act,
                    maxSpeed: response.car_act[0].Speedmax
                })
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default Configs;